<template>
    <v-ons-page>
        <ons-toolbar>
            <div class="left"><ons-back-button></ons-back-button></div>
            <div class="center">{{title}}</div>
            <div class="right">
                <v-ons-toolbar-button slot="right" modifier="white-content" @click="openLinkDialog = true">
                    <v-ons-icon icon="md-globe"></v-ons-icon>
                </v-ons-toolbar-button>
            </div>
        </ons-toolbar>
        <v-ons-alert-dialog modifier="rowfooter" :visible.sync="openLinkDialog">
            <span slot="title">Open in Browser?</span>
            <template slot="footer">
                <v-ons-alert-dialog-button @click="openLinkDialog = false">Cancel</v-ons-alert-dialog-button>
                <v-ons-alert-dialog-button @click="openLink" >YES</v-ons-alert-dialog-button>
            </template>
        </v-ons-alert-dialog>
        <iframe class="qf-embed" v-if="link" :src="link"></iframe>
    </v-ons-page>
</template>

<script>
    import SingleCollectionItem from "./SingleCollectionItem";
    export default {
        name: "SingleCollection",
        data() {
            return {
                link: null,
                openLinkDialog: false
            };
        },
        methods: {
            openSingleCollectionItem() {
                this.$store.commit('navigator/push', {
                    extends: SingleCollectionItem,
                });
            },
            openLink(){
                window.open(this.link, "_blank");
                this.openLinkDialog = false;
            }
        },
    }
</script>

<style scoped>
    .content {
        overflow-y: auto;
        height: 100%;
    }

    .qf-embed {
        width: 100%;
        height: 100%;
        border: none;
        display: block;
    }
</style>